define('sentient/aba/app',[
  'backbone',
  'underscore',
  'loglevel',
  'exports'
],
function(Backbone, _, log, exports) {

  log.trace('running App.js');

  var App = function() {
    _.extend(this, Backbone.Events);
    this.stepForward = function() {};
  };
  var singletonApp = _.once(App);
  return new singletonApp();

});



